import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ComponentInteractionService {
  private deshabilitarComboMedioPagoAportes = new BehaviorSubject<boolean>(
    false
  );
  deshabilitarComboMedioPagoAporte$ = this.deshabilitarComboMedioPagoAportes.asObservable();

  setDeshabilitarComboMedioPagoAportes(value: boolean) {
    this.deshabilitarComboMedioPagoAportes.next(value);
  }
}
